module.exports = __webpack_public_path__ + "static/img/map2.6274c36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/map2.png
// module id = sBG8
// module chunks = 0